import { schema as schemas } from 'normalizr'

import { schema as fileSchema } from './file'

export { collection } from './file'

export const schema = new schemas.Array(fileSchema)
